import { SIGNALR_EVENT_NAMES } from '../constants';
import {
  dynamicRoutingCompleted,
  dynamicRoutingFailed,
  etlCompleted,
  etlFailed,
  etlStarted,
  routePublishCompleted,
  routePublishFailed,
  routingProgress,
  shipmentDetected
} from '../eventHandlers/ibplanning';
const { IBPLANNING } = SIGNALR_EVENT_NAMES;
export const setupIbplanningEventListeners = (connection) => {
  //Dynamic Routing
  connection.on(IBPLANNING.dynamicRoutingCompleted, dynamicRoutingCompleted);
  connection.on(IBPLANNING.dynamicRoutingFailed, dynamicRoutingFailed);
  connection.on(IBPLANNING.routingProgress, routingProgress);

  //Route Publish
  connection.on(IBPLANNING.routePublishCompleted, routePublishCompleted);
  connection.on(IBPLANNING.routePublishFailed, routePublishFailed);
  //ETL
  connection.on(IBPLANNING.etlStarted, etlStarted);
  connection.on(IBPLANNING.etlCompleted, etlCompleted);
  connection.on(IBPLANNING.etlFailed, etlFailed);

  //New Shipments
  connection.on(IBPLANNING.shipmentDetected,shipmentDetected)
};
